// extracted by mini-css-extract-plugin
export var label = "_ev-2";
export var slideContainer = "_ev-0";
export var slider = "_ev-1";